var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11.8,
    viewBox: "0 0 444 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.469 181.25C388.245 141.828 386.459 120.478 372.244 106.551C355.988 90.625 329.825 90.625 277.5 90.625H222C169.674 90.625 143.511 90.625 127.256 106.551C111 122.477 111 148.11 111 199.375V290C111 341.265 111 366.897 127.256 382.824C143.511 398.75 169.674 398.75 222 398.75H277.5C329.825 398.75 355.988 398.75 372.244 382.824C388.5 366.897 388.5 341.265 388.5 290V271.875",
    stroke: "#FFFF",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 181.25V290C55.5 320.031 80.3483 344.375 111 344.375M333 90.625C333 60.5946 308.153 36.25 277.5 36.25H203.5C133.732 36.25 98.8483 36.25 77.174 57.4847C65.0902 69.3236 59.7433 85.1855 57.3776 108.75",
    stroke: "#FFFF",
    strokeWidth: 30,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.aa0eda4100a8696a2cc716d368643b28.svg";
export { ForwardRef as ReactComponent };